const getBestCdnPath = currentPublicPath => {

  // 私有化临时解决 直接使用 window.cdnPath
  if(process.env.isKA){
    return `${window.cdnPath}/`;
  }

  const { scheduledCdnDomain } = window;
  if (!scheduledCdnDomain) {
    return currentPublicPath;
  }
  if (!/^(https:)?(\/\/)?(sf|lf)/.test(currentPublicPath)) {
    return currentPublicPath;
  }
  return currentPublicPath.replaceAll(/(sf|lf).*\.com|\/obj\/[^\/]*\//g, match => {
    if (/(sf|lf).*\.com/.test(match)) {
      return scheduledCdnDomain;
    } else if (/\/obj\/[^\/]*\//.test(match)) {
      return scheduledCdnDomain.includes('larksuitecdn')
        ? '/obj/lark-static-us/'
        : '/obj/feishu-static/';
    } else {
      return match;
    }
  });
};

__webpack_public_path__ = getBestCdnPath(CDN_DEFAULT_PUBLISH_PATH);
